import DEVICE_GROUP_API from '../../api/device_group'

// initial state
const state = {
	groupList: []
}

// getters
const getters = {
	allGroups: state => state.groupList
}

// actions
const actions = {
	getAllGroups ({ commit }) {
		DEVICE_GROUP_API.fetchGroups(
			data => {
				var groupsFiltered = data.filter(function (item) {
					return !item.toLowerCase().includes('test') && item.trim() && !item.toLowerCase().includes('default')
				})

				commit('setGroups', groupsFiltered)
			}, e => {
				console.log(e)
			}
		)
	},

	getAllGroupsForProduct ({ commit }, product) {
		DEVICE_GROUP_API.fetchGroupsForProduct(
			product,
			data => {
				console.log('getAllGroupsForProduct Before', data)

				var groupsFilteredPerProduct = data.filter(function (item) {
					return !item.toLowerCase().includes('test') || !item
				})

				groupsFilteredPerProduct = groupsFilteredPerProduct.filter(function (item) {
					return !item.toLowerCase().includes('default')
				})

				console.log('getAllGroupsForProduct After', groupsFilteredPerProduct)
				// const groupsFilteredPerProduct = data;
				commit('setGroups', groupsFilteredPerProduct)
			}, e => {
				console.log(e)
			}
		)
	},

	addGroup ({ commit }, postParams) {
		DEVICE_GROUP_API.addGroup(postParams.product,
			postParams,
			() => {
				commit('addGroup', postParams.groupName)
			}, e => {
				console.log(e)
			}
		)
	},

	commitGroup ({ commit }, postParams) {
		commit('addGroup', postParams.groupName)
	},

	deleteGroup ({ commit }, group) {
		commit('delete', group)
	},

	resetGroups ({ commit }) {
		console.log('reset in Group Store')

		commit('reset')
	}
}

// mutations
const mutations = {
	setGroups (state, groups) {
		state.groupList = groups
	},

	addGroup (state, group) {
		state.groupList.push(group)
	},

	delete (state, group) {
		const indexGroup = state.groupList.indexOf(group)
		if (indexGroup >= 0) {
			state.groupList.splice(indexGroup, 1)
		}
	},

	reset (state) {
		state.groupList = []
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
